import { css } from 'linaria';

export const displayNone = css`
  display: none;
`;

export const textDecorationNone = css`
  text-decoration: none;
`;

export const hideScrollbar = css`
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const loader = css`
  height: 100%;
  margin: auto;
`;
